import React from 'react';
import {Helmet} from "react-helmet";
import Layout from '../../components/Layout';
import AudiForm from '../../components/AudiForm';
import ReturnToButton from '../../components/ReturnToButton';
import AFSDisclaimer from './AFSDisclaimer';
import MaintenanceMessage from '../../components/MaintenanceMessage';
import queryString from 'query-string';
import { gtmPageview } from '../../functions/gtm';
import {
    PATH_AFS_FEEDBACK,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_TEXTAREA,
    FIELD_CHECKBOX,
    FIELD_RADIO,
    UI_AUDI,
    MAINTENANCE_SF,
    DEFAULT_THEME
} from '../../constants';

const fields = [
    [
        {
            colClass: "col-12 col-medium-5",
            fields: [
                {
                    field: FIELD_TEXT,
                    name: "firstName",
                    label: "First name"
                },
                {
                    field: FIELD_TEXT,
                    name: "lastName",
                    label: "Last name"
                },
                {
                    field: FIELD_TEXT,
                    name: "emailAddress",
                    label: "Email"
                },
                {
                    field: FIELD_TEXT,
                    name: "phoneNumber",
                    label: "Phone number"
                },
                {
                    field: FIELD_RADIO,
                    name: 'contactType',
                    title: 'I would prefer to be contacted by',
                    options: [
                        {label: "Email", value: "Contact via Email", name: "contactType"},
                        {label: "Phone", value: "Contact via Phone", name: "contactType"}
                    ],
                    value: "Contact via Email"
                },
                {
                    field: FIELD_TEXT,
                    name: 'registrationNumber',
                    label: 'Vehicle Registration Number',
                    formatValue: (v) => { return v.toUpperCase(); }
                },
                {
                    field: FIELD_TEXT,
                    name: 'contractNumber',
                    label: 'Contract Number',
                    formatValue: (v) => { return v.toUpperCase().substring(0,15); }
                }
            ]
        },
        {
            colClass: "col-medium-1",
            node: (<span>&nbsp;</span>)
        },
        {
            colClass: "col-12 col-medium-6",
            fields: [
                {
                    field: FIELD_RADIO,
                    name: 'enquiryType',
                    title: 'Enquiry type',
                    options: [
                        {label: "Compliment", value: "Compliment", name: "enquiryType"},
                        {label: "Enquiry", value: "Enquiry", name: "enquiryType"},
                        {label: "Suggestion", value: "Suggestion", name: "enquiryType"},
                        {label: "Complaint", value: "Complaint", name: "enquiryType"}
                    ],
                    className: "stacked"
                },
                {
                    field: FIELD_TEXTAREA,
                    name: 'enquiry',
                    label: 'Please expand on your query'
                },
                {
                    field: FIELD_CHECKBOX,
                    name: "optIn",
                    label: "I would like to hear more about Audi Financial Services Offers.",
                    colClass: "col-12"
                },
                {
                    field: FIELD_CHECKBOX,
                    name: "termsAndConditions",
                    label:"Consent of Terms & Conditions and Privacy Policy.",
                    colClass: "col-12"
                }
            ]
        }
    ]
];

const validationSchema = {
    termsAndConditions: {
        truthy: {message: "You must agree to the Terms and Conditions and Privacy Policy"}
    },
    enquiry: {
        presence: {message: "This field is required", allowEmpty: false}
    },
    registrationNumber: {
        presence: {message: "Vehicle registration number is required", allowEmpty: false}
    },
    contractNumber: {
        presence: {message: "Please enter a valid contract number", allowEmpty: false}
    },
    enquiryType: {
        presence: {message: "Please choose an enquiry type", allowEmpty: false}
    }
};

class AFSFeedback extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            submittedData: {}
        }
    }

    componentDidMount() {
        gtmPageview(PATH_AFS_FEEDBACK);
    }

    onSubmit = (values) => {
        this.setState({submitted: true, submittedData: values});
        this.props.history.push(`${PATH_AFS_FEEDBACK}${PATH_THANKS}${this.props.location?.search}`);
        gtmPageview(`${PATH_AFS_FEEDBACK}${PATH_THANKS}`);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const {submitted, submittedData} = this.state;
        return (
            <Layout ui={query.ui || UI_AUDI} theme={theme}>
                <Helmet>
                    <title>Feedback | Audi Financial Services</title>
                </Helmet>

                <main className="audi-forms__page">

                    {submitted && <div className="pb-5">
                        <h1 className="aui-headline-3 mb-4 pt-3 pt-medium-5">Thank you for your feedback.</h1>
                        <p className="mb-5">Your feedback has been submitted and you will receive an email confirmation shortly.</p>
                        <div className="pb-5"><ReturnToButton query={query} theme={theme} /></div>
                    </div>}

                    {!submitted && <div className="pt-3 pt-medium-5">
                        {MAINTENANCE_SF && <MaintenanceMessage opts={[
                            <>Call us on <a className="aui-textlink" href="tel:1300734567">1300 734 567</a>, between 9am – 5pm (AEST), Monday – Friday.</>
                        ]} />}
                        <AudiForm formName="afs-feedback"
                            fields={fields}
                            schema={validationSchema}
                            onSubmitSuccess={this.onSubmit}
                            submitIsStretched={false}
                            theme={theme}
                        />
                        <AFSDisclaimer />
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default AFSFeedback;
